import React, { useState } from 'react';
import { Box, Grid, List, ListItem, ListItemText, Typography, TextField, Button, IconButton, Paper ,Stack,InputAdornment,Divider, FormGroup, FormControlLabel, Checkbox} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useDispatch, useSelector } from 'react-redux';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { previousStep } from '../../../../../slice/multiStepSlice';
import { Editor } from 'primereact/editor';
import CloseIcon from "@mui/icons-material/Close";
import showToast from '../../../../../components/Hot-Toast/showToast';
import { useTMutation } from '../../../../../utils/useTMutation';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';

export default function SkillSet() {
  const {  values } = useSelector((state) => state?.multiStep)
  const navigate = useNavigate();

  const [checkBoxLabel, setCheckBoxLabel] = useState("");
  const [moreChecklist,addMoreCheckList] = useState(false)
  const dispatch = useDispatch();
 const [checkListData,setCheckListData] = useState({
  checklistTtile: "",
  checklistOptions: [],
});

  const [checkListValue,setCheckListValue] = useState({
    ...values,
    checklistDiscription:values.specialityChecklist ? values.specialityChecklist[0]?.checklistDiscription : "",
    checkListData:values.specialityChecklist?.length > 0 ? values.specialityChecklist : [],
  }
  )
  const handleChange = (key, value ,fieldValue) => {
    if(key === "checklistDiscription"){
      setCheckListValue((prev) => ({ ...prev, [key]: value }));
    }else{
      fieldValue((prev) => ({ ...prev, [key]: value }));
    }
    // else{
    //   if (checkListData?.value?.length > 0) {
    //     checkListValue?.checkListData.push(checkListData);
    //     setCheckListValue(
    //       {
    //         fieldLabel: "",
    //         value: [],
    //       }
    //     )
    //   }
    // }
    // setCheckListValue((prev) => ({ ...prev, [key]: value }));
  };

  const addCheckBox = () => {
    if (checkListData?.index !== undefined) {
      // If index is defined, update the state with the current checkListData
      setCheckListData(prevState => {
        return { ...prevState, index: checkListData.index };
      });
    }
  
    if (checkBoxLabel !== "") {
      console.log("checkBoxLabel", checkBoxLabel);
  
      // Create a copy of the checklistOptions and push the new checkbox label
      const updatedChecklistOptions = [...checkListData?.checklistOptions, { checklistOption: checkBoxLabel }];
      
      // Update the state with the new checklistOptions
      setCheckListData(prevState => {
        return { 
          ...prevState, // Keep the other properties of checkListData unchanged
          checklistOptions: updatedChecklistOptions 
        };
      });
      
      // Clear the checkBoxLabel after updating
      setCheckBoxLabel("");
    }
  };
  


  const handleDeleteCheckBox = (provide, index, labelIndex) => {
    if (provide === "value") {
      // const updatedFieldData = [...checkListData];
      // console.log("updatedFieldData",updatedFieldData)
      setCheckListData((prev) => {
        const updatedFieldData = {...prev};
        console.log("updatedFieldData",updatedFieldData)
           updatedFieldData.checklistOptions = updatedFieldData.checklistOptions.filter(
          (_, i) => i !== index
        );
        return updatedFieldData;
        
      });


    }
    //  else if (provide === "chekBoxField") {
    //   setFieldData((prev) => {
    //     const updatedFieldData = [...prev];

    //     updatedFieldData[4].checkBox[labelIndex].value = updatedFieldData[4]?.checkBox[labelIndex].value?.filter(
    //       (_, i) => i !== index
    //     );
    //     if (updatedFieldData[4].checkBox[labelIndex]?.value?.length === 0) {
    //       updatedFieldData[4].checkBox = updatedFieldData[4]?.checkBox?.filter(
    //         (_, i) => i !== labelIndex
    //       );
    //     }
    //     return updatedFieldData;
    //   });
    // }
  }


  const addComponent = () => {
    if (checkListData?.index !== undefined) {
      console.log("checkListData", checkListData);
      console.log("checkListValue.checkListData[checkListData?.index]", checkListValue.checkListData[checkListData?.index]);
  
      setCheckListValue(prev => {
        const newArray = { ...prev }; 
  
        // Create a shallow copy of the checkListData array
        newArray.checkListData = [...prev.checkListData]; 
  
        // Modify the specific index in the new array
        newArray.checkListData[checkListData?.index] = { ...checkListData };
  
        return newArray;
      });
      
      console.log("checkListValue", checkListValue?.checkListData);
  
      // Reset checkListData
      setCheckListData({
        checklistTitle: "",
        checklistOptions: [],
      });
    } else if (checkListData?.checklistOptions?.length > 0) {
      setCheckListValue(prev => {
        const newArray = { ...prev };
        newArray.checkListData = [...prev.checkListData, { ...checkListData }];
        return newArray;
      });
  
      // Reset checkListData
      setCheckListData({
        checklistTitle: "",
        checklistOptions: [],
      });
    }
  };

  const handleEditCheckList = (index)=>{
    console.log("indexindex",index)

    addMoreCheckList(true);
     const editData = checkListValue?.checkListData[index]
     console.log("editData",editData)
     let newValue = {...editData,index}
     setCheckListData(newValue);
     console.log("checkListData",checkListData)
  }

  const { mutateAsync } = useTMutation(
    "/addChecklistAndAssessment",
    "post",
    (response) => {
      if (response.STATUS) {
        return response;
      }
    }
  );
  const submitAddDocument = async (data) => {
    
    try {
      console.log("checkListValuecheckListValue",checkListValue)
      if(checkListData?.options?.length > 0){
        showToast("error", "Please fill all data", 3000);
        return;
      }
      const deleteCurrent =values.specialityChecklist?.length > 0 && true;
      const s = deleteCurrent === true ? {...checkListValue , deleteCurrent} :  checkListValue;
      

      const response = await mutateAsync(s);
      console.log("sssss", response);
      if (response.STATUS) {
        showToast("success", response.MESSAGE, 3000);
        navigate(`/admin/profile-criteria/fetchSpecialtyRoleMappings`);
        // navigate("/admin/profile-criteria/OnBoardingDocuments");
      } else {
        showToast("error", data.MESSAGE, 3000);
      }
    } catch (error) {
      console.error("Add Request failed:", error);
      showToast("error", "Something went wrong, Please try again", 3000);
    }
  };

  const addMoreCheck =()=>{
    addMoreCheckList(true);
    setCheckListData({
      checklistTitle: "",
      checklistOptions: [],
    });
    setCheckBoxLabel("");
    

  }

  const handleRemoveMcq = (index) => {
    setCheckListValue(prev => {
      const newArray = { ...prev }; 
      newArray.checkListData = newArray.checkListData.filter((_, i) => i !== index);
      return newArray;
    });
};



  return (
    // <Box sx={{ p: 4, height: '100vh', bgcolor: '#f5f5f5' }}>
    //   <Grid container spacing={2} sx={{ height: '100%' }}>
    //     {/* Left Panel */}
    //     <Grid item xs={3}>
    //       <Paper sx={{ height: '100%', p: 2 }}>
    //         <Typography variant="h6" gutterBottom>
    //           Skill sets
    //         </Typography>
    //         <List>
    //           {['Professional knowledge and skills', 'Computerized charting', 'Age specific competency', 'Work settings', 'Equipment'].map((item, index) => (
    //             <ListItem button key={index} sx={{ mb: 1 }}>
    //               <CheckBoxOutlineBlankIcon sx={{ mr: 1, color: '#6ebe44' }} />
    //               <ListItemText primary={item} secondary="03 Skills" />
    //             </ListItem>
    //           ))}
    //         </List>
    //         <IconButton color="primary">
    //           <AddIcon />
    //         </IconButton>
    //       </Paper>
    //     </Grid>

    //     {/* Center Panel */}
    //     <Grid item xs={6}>
    //       <Paper sx={{ height: '100%', p: 2 }}>
    //         <Typography variant="h6" sx={{ color: '#6ebe44', mb: 2 }}>
    //           Professional knowledge and skills
    //         </Typography>
    //         <Box>
    //           {['Isolation Room', 'Skill 2'].map((skill, index) => (
    //             <TextField
    //               key={index}
    //               variant="outlined"
    //               value={skill}
    //               fullWidth
    //               sx={{ mb: 2, bgcolor: '#f0f9ef' }}
    //             />
    //           ))}
    //           <Button sx={{ textTransform: 'none', color: '#6ebe44' }}>Add skill</Button>
    //         </Box>
    //       </Paper>
    //     </Grid>

    //     {/* Right Panel */}
    //     <Grid item xs={3}>
    //       <Paper sx={{ height: '100%', p: 2 }}>
    //         <Typography variant="h6" gutterBottom>
    //           Settings
    //         </Typography>
    //         <Box sx={{ mb: 2 }}>
    //           <TextField
    //             label="Checklist"
    //             fullWidth
    //             variant="outlined"
    //             defaultValue="Rehab Counselor"
    //             sx={{ mb: 2 }}
    //           />
    //           <TextField
    //             label="Specialty"
    //             fullWidth
    //             variant="outlined"
    //             select
    //             SelectProps={{ native: true }}
    //             defaultValue="Rehab Counselor"
    //           >
    //             <option value="Rehab Counselor">Rehab Counselor</option>
    //             <option value="Specialist">Specialist</option>
    //           </TextField>
    //         </Box>
    //         <Box sx={{ mb: 2 }}>
    //           <TextField
    //             label="Status"
    //             fullWidth
    //             variant="outlined"
    //             select
    //             SelectProps={{ native: true }}
    //             defaultValue="Active"
    //           >
    //             <option value="Active">Active</option>
    //             <option value="Inactive">Inactive</option>
    //           </TextField>
    //         </Box>
    //         <Box display="flex" justifyContent="space-between">
    //           <Button variant="outlined" color="primary">
    //             Cancel
    //           </Button>
    //           <Button variant="contained" sx={{ bgcolor: '#6ebe44' }}>
    //             Save
    //           </Button>
    //         </Box>
    //       </Paper>
    //     </Grid>
    //   </Grid>
    // </Box>
<>
  {/* {!values.REDIRECT && (
    <Button
      onClick={() => dispatch(previousStep())}
       startIcon={<ArrowBackIosIcon sx={{ fontSize: "12px", color: "#000000" }} />}
      sx={{
        textTransform: 'none',
        fontWeight: 500,
        fontSize: "14px",
        padding: 3,
        minWidth: 0,
        color: '#6ebe44',
        '&:hover': { backgroundColor: '#f0f9ef' },
      }}
    >
    </Button>
  )} */}

  <Box sx={{ p: 4, bgcolor: '#f5f5f5' }}>
    <Grid container spacing={2} sx={{ height: '100%' }}>
      {/* Left Panel */}
      <Grid item xs={12} sm={4} md={3}>
        <Paper sx={{ height: '94%', p: 2, boxShadow: 3 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography variant="h6" gutterBottom>
             Check lists
            </Typography>
            <Stack spacing={2} direction="row">
              {/* <IconButton sx={{ border: "1px solid lightgrey", borderRadius: "50%" }}>
                <PlayArrowIcon sx={{ color: "#000" }} />
              </IconButton> */}
              <IconButton sx={{ border: "1px solid lightgrey", borderRadius: "50%" }} onClick={()=>{addMoreCheck()}}>
                <AddIcon sx={{ color: "#000" }} />
              </IconButton>
            </Stack>
          </Box>

          <List>
            {checkListValue?.checkListData?.map((item, index) => (
              <>
              <ListItem button key={index} sx={{ mb: 1 }} onClick={() => handleEditCheckList(index)}>
                {/* <CheckBoxOutlineBlankIcon sx={{ mr: 1, color: '#6ebe44' }} /> */}
                <InputAdornment position="start" sx={{ border: '1px solid #6ebe44', padding: '12px 8px' }}>
                    {String(index + 1)}
                  </InputAdornment>
                <ListItemText primary={item?.checklistTtile} secondary={`${item?.checklistOptions?.length} skills`} />
                <IconButton onClick={(e) => { e.stopPropagation(); handleRemoveMcq(index); }}>
               <DeleteIcon sx={{ color: 'red' }} />
             </IconButton>
              </ListItem>
            </>
            ))}
          </List>
        </Paper>
      </Grid>

      {/* Center Panel */}
      <Grid item xs={12} sm={6} md={6}>
        <Paper sx={{ p: 3, boxShadow: 3 }}>
          <Typography variant="h6" sx={{ color: '#6ebe44', mb: 2 }}>
            Professional knowledge and skills
          </Typography>

          <Editor
            value={checkListValue?.checklistDiscription}
            onTextChange={(e) => handleChange("checklistDiscription", e.htmlValue?.toString())}
            style={{ height: "320px" }}
          />
{moreChecklist && <>
  <Box sx={{ mb: 2,mt:2 }}>
            <TextField
              label="Title"
              fullWidth
              value={checkListData?.checklistTtile}
              onChange={(e) => handleChange("checklistTtile", e.target.value, setCheckListData)}
              variant="outlined"
              sx={{ bgcolor: '#f0f9ef' }}
            />
          </Box>

          <Box sx={{ mb: 2 }}>
            <TextField
              label="Options"
              fullWidth
              value={checkBoxLabel}
              onChange={(e) => setCheckBoxLabel(e.target.value)}
              variant="outlined"
              sx={{ bgcolor: '#f0f9ef' }}

              // InputProps={{
              //   startAdornment: (
              //     <InputAdornment position="start" sx={{ border: '1px solid #6ebe44', padding: '12px 8px' }}>
              //       {String.fromCharCode(index + 1)}
              //     </InputAdornment>
              //   ),
              // }}
            />
          </Box>

          <Grid container spacing={1}>
            {checkListData?.checklistOptions?.map((label, index) => (
              <Grid item xs={12} key={index} sx={{ display: "flex", alignItems: "center" }}>

<InputAdornment position="start" sx={{ border: '1px solid #6ebe44', padding: '12px 8px' }}>
                    {index + 1}
                  </InputAdornment>
                  <Typography>{label?.checklistOption}</Typography>
                {/* <FormGroup>
                  <FormControlLabel
                    control={<Checkbox />}
                    label={label?.checklistOption}
                  />
                </FormGroup> */}
                <CloseIcon sx={{ ml: 'auto' }} onClick={() => handleDeleteCheckBox("value", index)} />
              </Grid>
            ))}
          </Grid>

          <Box sx={{ mt: 2 }}>
            <Button variant="outlined" onClick={addCheckBox} sx={{ fontWeight: "bold", color: '#6ebe44' }}>
              + Add Options
            </Button>
          </Box>
{checkListData?.checklistOptions?.length > 0 && 
          <Button
            variant="contained"
            sx={{
              bgcolor: '#6ebe44',
              color: '#fff',
              mt: 2,
              '&:hover': { bgcolor: '#5a9d3f' },
            }}
            onClick={addComponent}
          >
            Add Checklist
          </Button>}

</>}
         
        </Paper>
      </Grid>

      {/* Right Panel */}
      <Grid item xs={12} sm={4} md={3}>
        <Paper sx={{ height: '94%', p: 2, boxShadow: 3 }}>
          <Typography variant="h6" gutterBottom>
            Settings
          </Typography>
          <Divider sx={{ mb: 3 }} />

          <Box>
            <TextField
              label="Checklist"
              disabled
              fullWidth
              variant="outlined"
              value={values?.checklistName}
              sx={{ mb: 2 }}
            />
            <TextField
              label="Specialty"
              disabled
              fullWidth
              variant="outlined"
              value={values?.SPECIALTY_NAME}
              sx={{ mb: 2 }}
            />
            <TextField
              label="Status"
              fullWidth
              variant="outlined"
              select
              SelectProps={{ native: true }}
              defaultValue="Active"
              sx={{ mb: 2 }}
            >
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </TextField>
          </Box>

          <Box sx={{ mt: 4, display: 'flex', justifyContent: 'flex-end' }}>
            <Button variant="outlined" sx={{ mr: 2 }} onClick={() =>navigate(`/admin/profile-criteria/fetchSpecialtyRoleMappings`)
}>
              Cancel
            </Button>
            <Button
              onClick={submitAddDocument}
              className='gradientAdminThemeColor'
            >
              Save
            </Button>
          </Box>
        </Paper>
      </Grid>
    </Grid>
  </Box>
</>


    
  );
}
